import {createAction, PayloadAction} from '@reduxjs/toolkit';
import {call, ForkEffect, put, takeLatest} from 'redux-saga/effects';

import {
  requesting,
  fail,
  updateProject,
  success,
} from 'App/features/searchEntities/lightProjects/lightProjectsSlice';
import {TFullProject} from 'App/features/searchEntities/lightProjects/lightProjectsTypes';

import * as log from '../../../../../logger';
import {update} from '../lightProjectsApi';

type RequestUpdateLightProjectPayload = {
  updatedLightProject: TFullProject;
  fields: Record<string, string>;
};

export const requestUpdateLightProject = createAction(
  'lightProjects/requestUpdateLightProjects',
);

function* requestUpdateLightProjectsSaga({
  payload,
}: PayloadAction<RequestUpdateLightProjectPayload>) {
  yield put(
    updateProject({
      updatedLightProject: {...payload.updatedLightProject, ...payload.fields},
    }),
  );
  yield put(requesting());
  try {
    const updatedLightProject: TFullProject = yield call(
      update,
      payload.updatedLightProject.hash,
      payload.fields,
    );
    yield put(updateProject({updatedLightProject}));
    yield put(success());
  } catch (error) {
    if (error instanceof Error) {
      yield call(log.exception, error);
    }
    yield put(fail({error: 'requestUpdateLightProjectError'}));
  }
}

function* watchUpdateLightProject(): Generator<
  ForkEffect<void>,
  void,
  unknown
> {
  yield takeLatest(
    requestUpdateLightProject.type,
    requestUpdateLightProjectsSaga,
  );
}

export default watchUpdateLightProject;
